const firebaseConfig = {
    apiKey: "AIzaSyAExIalOY40fcwHVGEj1LNpS1FEfdCmG30",
    authDomain: "ema-john-simpl.firebaseapp.com",
    databaseURL: "https://ema-john-simpl.firebaseio.com",
    projectId: "ema-john-simpl",
    storageBucket: "ema-john-simpl.appspot.com",
    messagingSenderId: "1080118174820",
    appId: "1:1080118174820:web:799384abc93e61a3b02b71"
  };

  export default firebaseConfig;